// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import cstmTable from "../../../../share/components/vue/PaginationTable";
import error from '../../../../common/nodejs/errors';
import config from '../../../../share/config';
import session from '../../../../share/session';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  INPUT_DIRECTION: 'inputDirection',
  INPUT_VALUE: 'inputValue',
  ERROR: 'error',
  FAILED: 'failed'
};

/** 調整方向定義 */
const DIRECTION_ID = {
  VERTICAL: 0,
  HORIZONTAL: 1
};
/** 調整値 */
const ADJUSTED_VALUE = {
  PARAM_MINUS_4: -4,
  PARAM_MINUS_3: -3,
  PARAM_MINUS_2: -2,
  PARAM_MINUS_1: -1,
  PARAM_0: 0,
  PARAM_1: 1,
  PARAM_2: 2,
  PARAM_3: 3,
  PARAM_4: 4
};

export default {
  name: 'requirement069',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      isDisableButton: true,
      bodyItemsDirection: [],
      bodyItemsParam: [],
      tableItemsDirection: [],
      tableItemsParam: [],
      columns: {
        vertical: this.$t(`individual.label_direction_vertical`),
        horizontal: this.$t(`individual.label_direction_horizontal`)
      },
      selectedItemDirection: {
        itemID: null,
        itemName: null
      },
      selectedItemParam: {
        itemID: null,
        itemName: null
      },
      selectedDirection: null,
      modal_requirement_069: false
    };
  },

  props: {
    workSupportId: { type: Number, default: '', required: true },
  },
  components: {
    'cstm-table': cstmTable
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.ERROR:
          return 'danger';
        case PHASE.START:
        case PHASE.INPUT_DIRECTION:
        case PHASE.INPUT_VALUE:
        default:
          return 'secondary';
      }
    },

    systemTableColumns() {
      this.tableItemsDirection = [
        {
          name: 'itemName',
          label: `individual.label_table_item`
        }
      ];
      return this.tableItemsDirection;
    },
    
    paramTableColumns() {
      this.tableItemsParam = [
        {
          name: 'itemName',
          label: `individual.label_table_parameter`
        }
      ];
      return this.tableItemsParam;
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),
    /** 調整方向用 選択された行番号を保持 */
    selectItemDirection(data) {
      this.isDisableButton = false;
      this.selectedItemDirection = {
        itemID: data.itemID,
        itemName: data.itemName
      };
      this.setHighLightDirection(this.selectedItemDirection.itemID);
    },

    /** 調整値用 選択された行番号を保持 */
    selectItemParam(data) {
      this.isDisableButton = false;
      this.selectedItemParam = {
        itemID: data.itemID,
        itemName: data.itemName
      };
      this.setHighLightParam(this.selectedItemParam.itemID);
    },

    /**
     * 調整方向用ハイライト設定
     * @param highLightItem // 強調表示するアイテムのID
     */
    setHighLightDirection(highLightItem) {
      this.bodyItemsDirection.forEach(item => {
        if (item.itemID === highLightItem) {
          item.fieldSpec = {};
          item.fieldSpec.itemName = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /**
     * 調整値用ハイライト設定
     * @param highLightItem // 強調表示するアイテムのID
     */
    setHighLightParam(highLightItem) {
      this.bodyItemsParam.forEach(item => {
        if (item.itemID === highLightItem) {
          item.fieldSpec = {};
          item.fieldSpec.itemName = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /** 初期化処理 */
    init() {
      this.modal_requirement_069 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_069 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      // 異常終了：エラー表示
      this.phase = PHASE.FAILED;
    },

    /** エラー画面 */
    privateError() {
      this.phase = PHASE.ERROR;
    },
    
    /** 終了時の処理 */
    async endProcessing() {
      this.closeWizard();

      // 初期画面に戻す
      this.phase = PHASE.INPUT_DIRECTION;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    // 各API実行-------------------------------------------

    /** 画面起動時の起動処理 */
    async start() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'standby'
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              this.setInputDirection();
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_069_COMMUNICATION_ERROR:
                  this.phase = PHASE.ERROR;
                  break;
                default:
                  this.showUnexpectedError();
                  return;
              }
              break;
            default:
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
        this.isDisableButton = true;
      }
    },

    /** データ読出し */
    async read() {
      try {
        this.isLoading = true;
        this.selectedDirection = this.selectedItemDirection.itemID;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          adjustment_direction: this.selectedDirection,
          type: 'read'
        };

        // データ読出し（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              this.setInputValue(response.data.user_data.read_adjusted_value);
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_069_COMMUNICATION_ERROR:
                  this.phase = PHASE.ERROR;
                  break;
                default:
                  this.showUnexpectedError();
                  return;
              }
              break;
            default:
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
        this.isDisableButton = true;
      }
    },

    /** 調整値変更 */
    async adjustment() {

      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          change_adjusted_deirection: this.selectedDirection,
          change_adjusted_value: this.selectedItemParam.itemName,
          type: 'change'
        };

        // ルーチン処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              this.setInputDirection();
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_069_COMMUNICATION_ERROR:
                  this.phase = PHASE.ERROR;
                  break;
                default:
                  this.showUnexpectedError();
                  return;
              }
              break;
            default:
              this.showUnexpectedError();
              return;
          }
        }

      } finally {
        this.isLoading = false;
        this.isDisableButton = true;
      }
    },

    /** 停止処理 */
    async stop() {
      try {
        // API実行
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'stop'
        };

        // 停止処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 終了処理
              this.endProcessing();
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_069_COMMUNICATION_ERROR:
                  this.phase = PHASE.ERROR;
                  break;
                default:
                  this.showUnexpectedError();
                  return;
              }
              break;
            default:
              this.showUnexpectedError();
              return;
          }
        }
      } finally {
        this.isLoading = false;
      }

    },

    /** 終了処理 */
    async terminate() {
      try {
        // API実行
        this.isLoading = true;

        // API実行パラメータ作成
        const systemId = individualDiagnose.getCurrentSystemId(this);
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: 'terminate'
        };

        // 終了処理（要求）
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );
      } finally {
        this.isLoading = false;

        // 終了処理
        this.endProcessing();
      }
    },

    // 表示内容の設定-------------------------------------------

    /**
     * 調整方向のテーブルを設定
     */
    setInputDirection() {

      // 画面遷移
      this.phase = PHASE.INPUT_DIRECTION;

      this.$nextTick(() => {
        // リスト表示項目の設定
        this.bodyItemsDirection = [
          {
            itemID: DIRECTION_ID.VERTICAL,
            itemName: this.columns.vertical
          },
          {
            itemID: DIRECTION_ID.HORIZONTAL,
            itemName: this.columns.horizontal
          }
        ];
      });
    },

    /**
     * 調整値のテーブルを設定
     * @param readData バックエンドから受け取ったデータ
     */
    setInputValue(readData) {

      // 画面遷移
      this.phase = PHASE.INPUT_VALUE;

      this.$nextTick(() => {
        // リスト表示項目の設定
        this.bodyItemsParam = [
          {
            itemID: 0,
            itemName: ADJUSTED_VALUE.PARAM_MINUS_4
          },
          {
            itemID: 1,
            itemName: ADJUSTED_VALUE.PARAM_MINUS_3
          },
          {
            itemID: 2,
            itemName: ADJUSTED_VALUE.PARAM_MINUS_2
          },
          {
            itemID: 3,
            itemName: ADJUSTED_VALUE.PARAM_MINUS_1
          },
          {
            itemID: 4,
            itemName: ADJUSTED_VALUE.PARAM_0
          },
          {
            itemID: 5,
            itemName: ADJUSTED_VALUE.PARAM_1
          },
          {
            itemID: 6,
            itemName: ADJUSTED_VALUE.PARAM_2
          },
          {
            itemID: 7,
            itemName: ADJUSTED_VALUE.PARAM_3
          },
          {
            itemID: 8,
            itemName: ADJUSTED_VALUE.PARAM_4
          }
        ];

        // 取得した値を選択状態にする
        this.bodyItemsParam.some((item) => {
          if (item.itemName === readData) {
            this.selectItemParam(item);
          }
        });
      });
    },

    // ユーザ操作-------------------------------------------

    /** 調整方向指定画面 OK押下処理 */
    onDirectionOkClicked() {
      this.isDisableButton = true;
      this.read();
    },

    /** 調整値指定画面 調整押下処理 */
    onValueAdjustmentClicked() {
      this.isDisableButton = true;
      this.adjustment();
    },

    /** 調整方向指定画面 終了押下処理 */
    onDirectionExitClicked() {
      this.isDisableButton = true;
      this.stop();
    },

    /** 調整値指定画面 キャンセル押下処理 */
    async onValueCancelClicked() {
      this.isDisableButton = true;
      this.setInputDirection();
    },

    /** エラー画面 OK押下処理 */
    onErrorOkClicked() {
      this.terminate();
    },
  },

  async mounted() {
    this.init();
    this.start();
  }
};
